<template>
  <div class="account-bind">
    <BindComp />
    <div class="other">
<!--      <BindOther />-->
    </div>
  </div>

</template>

<script>
import BindComp from "./components/BindComp";
import BindOther from "./components/BindOther";
export default {
  name: "AccountBind",
  components: {
    BindComp,
    BindOther
  }
};
</script>

<style lang='less' scoped>
</style>